import { AfterViewInit, Component, ContentChildren, Input, QueryList } from '@angular/core';
import { CheckboxProps, inputContainerStyles } from '@kite_aerolab/shared/components';
import { CheckboxComponent } from './checkbox.component';
import { getRandomID } from '@kite_aerolab/shared/utils';

@Component({
  selector: 'kite-checkbox-group',
  template: `
    <section [ngClass]="inputContainerStyles">
      <fieldset tabindex="0">
        <kite-stack direction="column" justify="space-between" spacing="xs">
          <legend
            kiteText
            size="sm"
            weight="bold"
            tabindex="0"
            [css]="{ color: isInvalid ? '$text_feedback_error' : '$text_default' }"
          >
            {{ title }}
          </legend>
          <ng-content></ng-content>

          <div kiteMessage *ngIf="isInvalid && error" [id]="id + '-feedback'" type="error">
            <kite-icon name="alert" size="sm"></kite-icon>
            {{ error }}
          </div>
          <div kiteMessage *ngIf="!isInvalid && helper" [id]="id + '-helptext'">{{ helper }}</div>
        </kite-stack>
      </fieldset>
    </section>
  `,
})
export class CheckboxGroupComponent implements AfterViewInit {
  /**
   * ID del checkbox.
   */
  @Input() id: string = getRandomID();
  /**
   * Required del checkbox.
   */
  @Input() required: boolean;
  /**
   * Css
   */
  @Input() css: CheckboxProps['css'];
  /**
   * El grupo es invalido
   */
  @Input() isInvalid: boolean;

  /**
   * Texto de ayuda
   */
  @Input() helper: string;

  /**
   * Texto de error
   */
  @Input() error: string;

  /**
   * Título del grupo
   */
  @Input() title: string;
  /**
   *
   */
  @Input() isDisabled: boolean;
  /**
   *
   */
  @Input() isRequired: boolean;

  @ContentChildren(CheckboxComponent) items: QueryList<CheckboxComponent>;

  public get inputContainerStyles(): string[] {
    return [inputContainerStyles().className];
  }

  ngAfterViewInit() {
    this.items.forEach((item) => {
      if (this.isInvalid) {
        // Si el grupo es invalido, se lo agregamos a los checkboxs
        item.isInvalid = true;
      }
      if (this.isDisabled) {
        // Si el grupo esta desabilitado, se lo agregamos a los checkboxs
        item.isDisabled = true;
      }
      if (this.isRequired) {
        // Si el grupo es requerido, se lo agregamos a los checkboxs
        item.isRequired = true;
      }
    });
  }
}
